import { Component, OnInit } from '@angular/core';
import { DEPARTMENT_TYPE_COACHTRAINING } from '@core/constants';
import { EventsService } from 'src/app/modules/events/events.service';

@Component({
    selector: 'app-events',
    templateUrl: './events.component.html',
    styleUrls: ['./events.component.scss'],
})
export class CoachTrainingEventsComponent implements OnInit {
    departmentType: string = DEPARTMENT_TYPE_COACHTRAINING;

    registers: any;
    statusCode: number;
    filters: any;
    loadAll = 1;
    loading: boolean = false;

    constructor(private eventsService: EventsService) {}

    ngOnInit(): void {
        this.getEvents();
    }

    getEvents(filters = null) {
        this.loading = true;

        this.eventsService.getEvents({ ...filters, departmentType: this.departmentType }).subscribe((response) => {
            this.loading = false;
            this.filters = response.registers.filters;
            this.registers = response.registers.list;
        });
    }

    /**
     * onFiltersChange(): Ao mudar parãmetro de filtro
     * @param event Objeto com parâmetros selecionados/alterado através do filtro
     */
    onFiltersChange(event) {
        this.getEvents(event);
    }
}
